











































































import {Component, Vue} from 'vue-property-decorator';
import {
  卸別入出庫集計依頼型,
  卸別入出庫集計条件バリデータ一覧,
  卸別入出庫集計型,
  卸型,
} from '@/type/stock/summary/receive_delivery_summary';
import { ValidationResult } from '@/type/validation/result';

import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import {progress} from '@/script/progress';

import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import moment from 'moment';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import ReceiveDeliveryItemDetails from '@/views/stock/summary/ReceiveDeliveryItemDetails.vue';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    NormalDialog,
    ReceiveDeliveryItemDetails,
  },
})
export default class ListReceiveDeliverySummaries extends Vue {
  private アラートメッセージ: string | string[] | null = null;

  private 卸別入出庫集計依頼: 卸別入出庫集計依頼型 = this.入出庫集計条件初期値();
  private 直近卸別入出庫集計依頼: 卸別入出庫集計依頼型 | null = null;
  private 卸別入出庫集計一覧: 卸別入出庫集計型[] = [];
  private 集計一覧に含まれる卸一覧: 卸型[] = [];
  private 選択卸別入出庫集計: 卸別入出庫集計型 | null = null;
  private 選択中の行index: number | null = null;

  private 集計条件バリデーション結果: ValidationResult = new ValidationResult(卸別入出庫集計条件バリデータ一覧);
  private modal: boolean = false;

  private created(): void {
    moment.locale('ja');
    this.initialize();
  }

  private initialize() {
    this.卸別入出庫集計依頼 = this.入出庫集計条件初期値();
    this.直近卸別入出庫集計依頼 = null;
    this.卸別入出庫集計一覧 = [];
    this.集計一覧に含まれる卸一覧 = [];
    this.アラートメッセージ = null;
  }

  private 入出庫集計条件初期値(): 卸別入出庫集計依頼型 {
    return {
      集計期間From: moment().startOf('month').toDate(),
      集計期間To: moment().toDate(),
    };
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private async 集計する(): Promise<void> {
    this.直近卸別入出庫集計依頼 = {...this.卸別入出庫集計依頼};
    await api.卸別入出庫を集計する(this.直近卸別入出庫集計依頼)
      .then((response: any) => {
        this.卸別入出庫集計一覧 = response.卸別入出庫集計結果一覧;
        this.集計一覧に含まれる卸一覧 = this.卸別入出庫集計一覧.map((卸別入出庫集計) => {
          return {卸コード: 卸別入出庫集計.卸コード, 卸名: 卸別入出庫集計.卸名} as 卸型;
        });
        if (this.卸別入出庫集計一覧.length === 0) {
          this.アラートメッセージ = '該当の入庫は存在しません';
          this.$modal.show('アラート');
          return;
        }
        if (response.アラートメッセージ) {
          this.アラートメッセージ = response.アラートメッセージ;
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
        this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
        this.$modal.show('アラート');
      });
  }

  private async 集計するハンドラ(): Promise<void> {
    if (this.集計条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.集計条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    await progress(this.集計する);
  }

  private async 出力する(): Promise<void> {
    if (!this.卸別入出庫集計依頼) {
      return;
    }

    await download.卸別入出庫一覧表を出力する('卸別入出庫集計表_卸別.xlsx', this.卸別入出庫集計依頼);
    this.ダイアログを閉じる('出力ダイアログ');
  }

  private async 出力するハンドラ(): Promise<void> {
    await progress(this.出力する);
  }

  private async Excelファイル出力前入力チェックをする(): Promise<void> {
    if (this.集計条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.集計条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    this.ダイアログを開く('出力ダイアログ');
  }

  private クリアする(): void {
    this.initialize();
    this.ダイアログを閉じる('クリアダイアログ');
  }

  private 行が選択されている(index: number) {
    return this.選択中の行index === index;
  }

  private async リスト選択時の処理(index: number) {
    this.選択中の行index = index;
  }

  private 入力エラー判定(項目名: string): boolean {
    return this.集計条件バリデーション結果.hasError(項目名);
  }

  private beforeUpdate(): void {
    this.集計条件バリデーション結果.validate(this.卸別入出庫集計依頼);
  }

  private closeDialog(): void {
    this.modal = false;
  }

  private 品目情報を表示する(選択卸別入出庫集計: 卸別入出庫集計型): void {
    this.選択卸別入出庫集計 = 選択卸別入出庫集計;
    this.modal = true;
  }

  private アラートダイアログを開く(event: Event) {
    this.アラートメッセージ = event.toString().split(',');
    this.$modal.show('アラート');
  }

  private APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }
}
